import React from "react";
import { useMediaQuery } from "@mui/material";
import { useRouteActivity } from "~/hooks/useRouteActivity";
import { TopProgressBar } from "./TopProgressBar";
import "./RoutePendingUI.css";

type RoutePendingUIProps = {
  children: React.ReactNode;
};

/**
 * Cross-route pending UI (stage 1).
 * - Mobile (≤600px): top progress bar only, no dim overlay.
 * - Larger screens: dim + centered progress bar.
 */
export const RoutePendingUI: React.FC<RoutePendingUIProps> = ({ children }) => {
  const { showLayoutOverlay } = useRouteActivity();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const showDimOverlay = showLayoutOverlay && !isMobile;
  const showMobileBar = showLayoutOverlay && isMobile;

  return (
    <>
      <div
        className={
          showDimOverlay ? "route-pending-content-dimmed" : undefined
        }
      >
        {children}
      </div>
      {showMobileBar && (
        <div
          className="route-pending-progress--mobile"
          role="progressbar"
          aria-label="Page loading"
        >
          <TopProgressBar />
        </div>
      )}
      {showDimOverlay && (
        <div
          className="route-pending-overlay route-pending-overlay--fixed"
          aria-hidden
        >
          <div className="route-pending-progress--centered">
            <TopProgressBar />
          </div>
        </div>
      )}
    </>
  );
};
